<template>
  <v-navigation-drawer
    app
    location="left"
    v-model="drawer"
    width="250"
    height="100%"
    class="k-app-sidebar"
    v-if="user && activeWorkspace"
  >
    <div class="k-app-sidebar-head pa-2">
      <div class="personal-widget-sidebar">
        <div class="personal-widget">
          <v-img
            v-if="activeWorkspace?.logo"
            class="workspace-logo"
            :style="`background-color: ${activeWorkspace?.color || '#24a1c7'}`"
            :src="activeWorkspace?.logo"
            :alt="activeWorkspace?.name"
          ></v-img>
          <div
            v-else
            class="workspace-logo no-logo"
            :style="`background-color: ${activeWorkspace?.color || '#24a1c7'}`"
          >
            {{ activeWorkspace?.name?.charAt(0) || "N" }}
          </div>
          <div class="personal-widget-titles">
            <v-list-item-title v-text="activeWorkspace?.name"></v-list-item-title>
            <v-list-item-subtitle v-text="user.first_name"></v-list-item-subtitle>
          </div>
          <i class="fal fa-chevron-down"></i>
        </div>
        <v-menu
          activator="parent"
          class="workspace-menu"
          transition="slide-y-transition"
          location="bottom"
        >
          <v-card class="k-card-border">
            <div class="personal-widget">
              <v-img
                v-if="activeWorkspace?.logo"
                class="workspace-logo"
                :style="`background-color: ${activeWorkspace?.color || '#24a1c7'}`"
                :src="activeWorkspace?.logo"
              ></v-img>
              <div
                v-else
                class="workspace-logo no-logo"
                :style="`background-color: ${activeWorkspace?.color || '#24a1c7'}`"
              >
                {{ activeWorkspace?.name.charAt(0) }}
              </div>
              <div class="personal-widget-titles">
                <v-list-item-title v-text="activeWorkspace.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="workspace_plan_members"
                ></v-list-item-subtitle>
              </div>
              <div class="ml-auto text-right py-2 mr-n2">
                <v-btn
                  icon
                  elevation="0"
                  class="btn btn-sm"
                  size="small"
                  :to="`/settings`"
                >
                  <ui-icon name="settings" />
                </v-btn>
              </div>
            </div>

            <v-divider></v-divider>
            <v-list
              class="menu-small switch-workspaces-list"
              density="compact"
              :lines="false"
              :color="`${activeWorkspace?.color || '#24a1c7'}`"
            >
              <v-list-item
                v-for="workspace in activeWorkspaceslist"
                :key="workspace.id"
                @click="selectWorkspace(workspace.id)"
              >
                <template v-slot:prepend>
                  <v-img
                    v-if="workspace?.logo"
                    class="workspace-logo"
                    :style="`background-color: ${workspace?.color || '#24a1c7'}`"
                    :src="workspace?.logo"
                  ></v-img>
                  <div
                    v-else
                    class="workspace-logo no-logo"
                    :style="`background-color:${workspace?.color || '#24a1c7'}`"
                  >
                    {{ workspace?.name.charAt(0) }}
                  </div>
                </template>

                <v-list-item-title v-text="workspace.name"></v-list-item-title>
              </v-list-item>

              <ui-list-item
                icon="plus"
                :title="$t('add_workspace')"
                to="/workspace-setup"
              ></ui-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </div>

    <div class="k-app-sidebar-body">
      <v-list density="compact" nav :lines="false" color="var(--primary)">
        <ui-list-item
          :icon="item.icon"
          :title="item.title"
          v-for="(item, index) in getMenuItems()"
          :key="index"
          :to="item.to"
        />
      </v-list>
    </div>

    <div class="k-app-sidebar-footer">
      <div class="pa-3">
        <TrialCard :workspace="activeWorkspace" :hasSubscription="userHasPaidPlan" />
      </div>
      <div class="pa-3">
        <p class="text-overline">Workspace</p>
      </div>
      <v-list
        class="menu-small"
        density="compact"
        nav
        :lines="false"
        color="var(--primary)"
      >
        <ui-list-item
          :icon="item.icon"
          :title="item.title"
          v-for="(item, index) in getMenuItemsFooter()"
          :key="index"
          :to="item.to"
        />
      </v-list>
    </div>
    <NewAppDialog v-model="NewAppDialog" @close="NewAppDialog = false" />
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from "pinia";
  import { useMainStore } from "@/stores/store";
  import WorkspaceService from "@/services/WorkspaceServices";
  import api from "@/services/api";
  import NewAppDialog from "@/components/apps/dialogs/NewAppDialog.vue";
  import TrialCard from "@/components/home/TrialCard.vue";
  export default {
    data() {
      return {
        NewAppDialog: false,
        drawer: true,
        selectedmenuitems: [],
        workspaces_list: [],
        expand: true,
      };
    },

    components: {
      NewAppDialog,
      TrialCard,
    },
    computed: {
      ...mapState(useMainStore, ["user", "workspaces", "kyano"]),

      workspace_id() {
        return this.user.active_workspace_id;
      },

      userHasPaidPlan() {
        return useMainStore().userHasPaidPlan;
      },

      activeWorkspace() {
        if (!Array.isArray(this.workspaces_list)) {
          return {};
        }

        return this.user.active_workspace || {};
      },

      activeWorkspaceslist() {
        return this.workspaces_list.filter((workspace) => workspace.status === "active");
      },
    },
    methods: {
      getMenuItems() {
        return [{ title: "Apps", to: `/${this.workspace_id}/`, icon: "layout-grid" }];
      },

      async fetchWorkspaces() {
        try {
          const response = await WorkspaceService.getWorkspaces();
          if (response.data && Array.isArray(response.data.workspaces)) {
            this.workspaces_list = response.data.workspaces;
          } else {
            this.workspaces_list = [];
          }
        } catch (error) {
          console.error("Error fetching workspaces:", error);
          this.workspaces_list = [];
        }
      },

      waitForWorkspaceId() {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            if (this.user.active_workspace_id) {
              clearInterval(interval);
              resolve();
            }
          }, 100);
        });
      },

      selectWorkspace(workspaceId) {
        api
          .post("/api/v1/users/me/active-workspace", {
            workspace_id: workspaceId,
          })
          .then((response) => {
            this.dialogVisible = false; // Close the dialog

            // Programmatically navigate to the dashboard of the new workspace
            window.location.href = `/${workspaceId}`;
          })
          .catch((error) => {
            console.error(
              "Error selecting workspace",
              error.response?.data || error.message
            );
            this.$toast.error(error.response?.data || error.message);
          });
      },

      updateSelectedItems(newSelectedItems) {
        this.selectedmenuitems = newSelectedItems;
      },

      getMenuItemsFooter() {
        return [
          // {
          //   title: "Upgrade",
          //   to: `/upgrade`,
          //   icon: "rocket",
          // },
          // {
          //   title: "Members",
          //   to: `/members`,
          //   icon: "users",
          // },
          // {
          //   title: "Usage",
          //   to: `/usage`,
          //   icon: "chart-bar-big",
          // },
          // {
          //   title: "Administratie",
          //   to: `/billing`,
          //   icon: "banknote",
          // },
          {
            title: this.$t("my_profile"),
            to: `/account`,
            icon: "user-cog",
          },
          {
            title: this.$t("settings"),
            to: `/settings`,
            icon: "settings",
          },
        ];
      },
    },
    mounted() {
      this.fetchWorkspaces();
    },
  };
</script>
